document.addEventListener("DOMContentLoaded", function() {
  const sections = document.querySelectorAll("section");

  sections.forEach(section => {
    const tabs = section.querySelectorAll(".js-tab");
    const sliders = section.querySelectorAll(".js-tab-content");
    const notes = section.querySelectorAll(".js-tab-note"); // Выбираем все элементы с классом js-tab-note

    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        tabs.forEach(t => t.classList.remove("_active"));
        sliders.forEach(slider => slider.classList.remove("_active"));
        notes.forEach(note => note.classList.remove("_visible")); // Убираем класс _visible у всех js-tab-note

        tab.classList.add("_active");

        const tabId = tab.getAttribute("id");
        const correspondingSlider = section.querySelector(`[data-tab="${tabId}"]`);
        correspondingSlider.classList.add("_active");

        // Добавляем класс _visible только к соответствующему js-tab-note
        const correspondingNote = section.querySelector(`[data-note="${tabId}"]`);
        correspondingNote.classList.add("_visible");
      });
    });
  });
});